<template>
	<b-container id="label-generator" v-if="$can('view-label-generator') || $can('view-all')" fluid>
        <b-row class="page-title">
            <b-container fluid>
                <h3>Label Generator</h3>
                <hr>
            </b-container>
        </b-row>

        <b-row class="button-row">
            <b-col cols="2">
                <b-button size="sm" variant="outline-dark" @click="generateReport('pdf', false)">PDF</b-button>
                <b-button size="sm" variant="outline-dark" @click="generateReport('print', false)">PRINT</b-button>
                <b-button size="sm" variant="outline-dark" @click="generateReport('print', true)">PRINT LABEL</b-button>
                <b-button size="sm" variant="outline-dark" @click="openModal('excel-paste')">PASTE CSV</b-button>
            </b-col>
            <b-col cols="2">
                <b-form inline>
                    <label class="mr-sm-2" for="inline-form-select-wh">WH</label>
                    <b-form-select
                        id="inline-form-select-wh"
                        class="mb-2 mr-sm-2 mb-sm-0"
                        v-model="row.wh"
                        :options="locations"
                    >
                    </b-form-select>
                </b-form>
            </b-col>
            <b-col class="text-right" cols="3">
                <b-button size="sm" variant="outline-danger" @click="resetView"><i class="fas fa-redo fa-2x"></i> Reset View</b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="5">
                <b-table-simple hover small responsive bordered sticky-header="550px">
                    <b-thead>
                        <b-tr>
                            <b-th class="text-center">Photo</b-th>
                            <b-th class="text-center">
                                <b-form-checkbox
                                    id="checkbox-all"
                                    v-model="checkAll"
                                    name="checkbox-all"
                                    value="true"
                                    :unchecked-value="false"
                                    >
                                </b-form-checkbox>
                            </b-th>
                            <b-th>SKU</b-th>
                            <b-th class="qty text-center">QTY</b-th>
                            <b-th>Notes</b-th>
                        </b-tr>
                    </b-thead>
                    <b-tbody>
                        <b-tr v-for="(item, index) in row.items" :key="index" :class="`index-${index}`">
                            <td class="text-center">
                                <b-img-lazy v-if="row.items[index].url" class="products-thumbs" :src="item.url"></b-img-lazy>
                            </td>
                            <td class="text-center">
                                <b-form-checkbox
                                    :id="'checkbox-title-' + index"
                                    v-model="row.items[index].printPhoto"
                                    name="checkbox-title"
                                    :unchecked-value="false"
                                    >
                                </b-form-checkbox>
                            </td>
                            <td>
                                <autosuggest-instance
                                    :key="index"
                                    :idx="index"
                                    @nextRow="nextRow"
                                    @suggestFirstRow="suggestFirst"
                                    @onSelectedRow="onSelected"
                                    @focusMeRow="focusMe(index)"
                                    :ref="'skuinput' + index"
                                />
                            </td>
                            <td>
                                <b-form-input v-model="row.items[index].qty" size="sm" class="text-center" @focus="focusMe(index)"></b-form-input>
                            </td>
                            <td>
                                <b-form-input v-model="row.items[index].notes" size="sm" @focus="focusMe(index)"></b-form-input>
                            </td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
            </b-col>
        </b-row>

        <b-row>
            <b-col cols="1">
                <b-button size="sm" @click="addTenRows"><i class="fas fa-plus"></i> 10</b-button>
            </b-col>
        </b-row>

        <vue-html2pdf
            :show-layout="false"
            :float-layout="true"
            :enable-download="html2Pdf.enableDownload"
            :preview-modal="html2Pdf.previewModal"
            :filename="'label_generator_' + +new Date()"
            :pdf-quality="2"
            :manual-pagination="true"
            :pdf-format="html2Pdf.pdfFormat"
            :pdf-orientation="html2Pdf.orientation"
            pdf-content-width="98%"

            @progress="onProgress($event)"
            @hasStartedGeneration="hasStartedGeneration()"
            @hasGenerated="hasGenerated($event)"
            ref="html2Pdf"
        >
            <section slot="pdf-content">
                <div v-if="html2Pdf.isLabel">
                    <b-container class="html2pdf__page-break" style="margin-top: 5px; border: 3px solid; width: 5.5in; height: 4in;"
                        v-if="row.preparedItems" v-for="(item, index) in row.preparedItems" :key="index" fluid>
                        <b-row style="border-bottom: 1px solid; height: 1.1in;" align-v="center">
                            <b-col class="text-center">
                                <span :style="{ fontSize: html2Pdf.skuFontSize }"><strong>{{ item.sku }}</strong></span>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="text-center" cols="6" style="border-right: 1px solid;">
                                <div v-if="item.printPhoto != 'undefined' && item.printPhoto">
                                    <span style="display: inline-block; height: 100%; vertical-align: middle;"></span>
                                    <b-img style="max-height: 230px; vertical-align: middle;" v-if="item.urlMed" :src="item.urlMed"></b-img>
                                </div>

                                <div v-else>
                                    <b-row style="height: 1in; font-size: 20pt; padding-top: 5px;">
                                        <b-col>
                                            [ {{ new Date() | moment('MM-DD-YYYY') }} ]
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col>
                                            <strong>BOX COUNT</strong>
                                            <div
                                                style="margin-left: auto; margin-right: auto; width: 100px; height: 100px; border: 1px dashed #CCC;">
                                                &nbsp;</div>
                                        </b-col>
                                    </b-row>
                                    <b-row style="text-align: left;">
                                        <b-col>
                                            <span style="text-decoration: underline; font-weight: bold;">Initials:</span>
                                        </b-col>
                                    </b-row>
                                </div>
                            </b-col>

                            <b-col cols="6">
                                <b-row style="border-bottom: 1px solid; height: 0.85in;" align-v="center">
                                    <b-col class="text-center">
                                        <span style="font-size: 14pt;"><strong>{{ item.notes }}</strong></span>
                                    </b-col>
                                </b-row>
                                <b-row style="border-bottom: 1px solid; height: 1in;" align-v="center">
                                    <b-col class="text-center">
                                        <span style="font-size: 14pt;"><strong>{{ item.title }}</strong></span>
                                    </b-col>
                                </b-row>
                                <b-row style="border-bottom: 1px solid; height: 1in;" align-v="center">
                                    <b-col class="text-center" cols="6" style="border-right: 1px solid;">
                                        <barcode height="45" width="1" :value="item.sku" />
                                    </b-col>
                                    <b-col class="text-center" cols="6">
                                        <vue-qrcode style="width: 85px;"
                                            :value="env.COMPANY_APP_URL + '/inventory/products/details/' + item.sku" :quality=1 :width=1 />
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </b-container>
                </div>
                <div v-else>
                    <b-container v-bind:class="breaker(index + 1)" style="border: 3px solid; margin-top: 60px; height: 4.5in; width: 95%;" v-if="row.preparedItems" v-for="(item, index) in row.preparedItems" :key="index" fluid>
                        <b-row style="border-bottom: 1px solid; height: 1.1in;" align-v="center">
                            <b-col class="text-center">
                                <span :style="{ fontSize: html2Pdf.skuFontSize }"><strong>{{ item.sku }}</strong></span>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="text-center" cols="6" style="border-right: 1px solid;">
                                <div v-if="item.printPhoto != 'undefined' && item.printPhoto">
                                    <span style="display: inline-block; height: 100%; vertical-align: middle;"></span>
                                    <b-img style="width: 300px; height: 300px; vertical-align: middle;" v-if="item.urlMed" :src="item.urlMed"></b-img>
                                </div>

                                <div v-else>
                                    <b-row style="height: 1in; font-size: 20pt; padding-top: 5px;">
                                        <b-col>
                                            [ {{ new Date() | moment('MM-DD-YYYY') }} ]
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col>
                                            <strong>BOX COUNT</strong>
                                            <div style="margin-left: auto; margin-right: auto; width: 150px; height: 150px; border: 1px dashed #CCC;">&nbsp;</div>
                                        </b-col>
                                    </b-row>
                                    <b-row style="text-align: left; padding-top: 25px;">
                                        <b-col>
                                            <span style="text-decoration: underline; font-weight: bold;">Initials:</span>
                                        </b-col>
                                    </b-row>
                                </div>
                            </b-col>

                            <b-col cols="6">
                                <b-row style="border-bottom: 1px solid; height: 1in;" align-v="center">
                                    <b-col class="text-center">
                                        <span style="font-size: 24pt;"><strong>{{ item.notes }}</strong></span>
                                    </b-col>
                                </b-row>
                                <b-row style="border-bottom: 1px solid; height: 1.36in;" align-v="center">
                                    <b-col class="text-center">
                                        <span style="font-size: 14pt;"><strong>{{ item.title }}</strong></span>
                                    </b-col>
                                </b-row>
                                <b-row style="border-bottom: 1px solid; height: 1in;" align-v="center">
                                    <b-col class="text-center" cols="6" style="border-right: 1px solid;">
                                        <barcode
                                            height="45"
                                            width="1.5"
                                            :value="item.sku"
                                        />
                                    </b-col>
                                    <b-col class="text-center" cols="6">
                                        <vue-qrcode
                                            style="width: 93px;"
                                            :value="env.COMPANY_APP_URL + '/inventory/products/details/' + item.sku"
                                            :quality=1
                                            :width=1
                                        />
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </b-container>
                </div>
            </section>
        </vue-html2pdf>

        <modal-excel-paste v-if="modals['modal-warehousing-labelgenerator-excel-paste'].active"
            @updateRowItems="updateRowItems" />
    </b-container>
</template>

<script>
    import { VueAutosuggest } from "vue-autosuggest"
    import AutosuggestInstance from '../../../user/inventory/products/AutosuggestInstance'
    import { debounce } from 'vue-debounce'
    import VueBarcode from 'vue-barcode'
    import VueHtml2pdf from 'vue-html2pdf'
    import VueQrcode from 'vue-qrcode'
    import ModalExcelPaste from './modals/ExcelPaste'
    import { pathToFileURL } from "url"
	export default {
        components: {
            VueAutosuggest,
            AutosuggestInstance,
            'barcode': VueBarcode,
            VueHtml2pdf,
            VueQrcode,
            'modal-excel-paste': ModalExcelPaste,
        },

		data() {
			return {
                name: 'LabelGenerator',

                metaInfo() {
                    return {
                        title: 'Label Generator',
                    }
                },

                modals: {
                    'modal-warehousing-labelgenerator-excel-paste': {
                        active: 0
                    }
                },

                barcodeValue: '',

                autosuggest: {
                    debounceMilliseconds: 500,
                    timeout: null
                },

                cacheKey: 1,

                row: {
                    wh: 'A',
                    items: [],
                    preparedItems: []
                },

                locations: ['A', 'B'],

                products: [
                    {
                        data: []
                    }
                ],

                currentIndex: '',

                html2Pdf: {
                    enableDownload: false,
                    previewModal: false,
                    pdfFormat: 'letter',
                    skuFontSize: '50pt',
                    isLabel: false
                }
			}
		},

        methods: {
            updateRowItems(rows) {
                this.resetView(rows.length)

                this.$nextTick(() => {
                    rows.forEach((row, idx, array) => {
                        this.$refs['skuinput' + idx][0].$el.childNodes[0].childNodes[0].childNodes[0].childNodes[0].value = row.sku
                        this.$refs['skuinput' + idx][0].query = row.sku
                        this.row.items[idx].sku = row.sku
                        this.row.items[idx].url = row.url
                        this.row.items[idx].urlMed = row.urlMed
                        this.row.items[idx].qty = row.qty
                        this.row.items[idx].notes = row.notes
                        this.row.items[idx].title = row.title
                    })
                })
            },

            openModal(modalName, row, area) {
                let prefix = 'modal-warehousing-labelgenerator-'
                switch (modalName) {
                    case 'excel-paste':
                        this.modals[prefix + modalName].active = 1
                        break;
                }

                this.$nextTick(() => {
                    this.$bvModal.show(prefix + modalName)
                })
            },

            nextRow(idx, col) {
                let target = col + 'input' + (idx + 1)

                if (col == 'sku') {
                    this.$refs[target][0].$el.childNodes[0].childNodes[0].childNodes[0].childNodes[0].focus()
                } else {
                    this.$refs[target][0].$el.focus()
                }
            },

            breaker(index) {
                if (index % 2 == 0) {
                    return ['html2pdf__page-break']
                }
            },

            generateReport(type, isLabel) {
                this.html2Pdf.isLabel = isLabel
                let previewModal = type == 'pdf' ? false : true
                let enableDownload = type == 'pdf' ? true : false
                this.html2Pdf.pdfFormat = isLabel ? 'a6' : 'letter',
                this.html2Pdf.orientation = isLabel ? 'landscape' : 'portrait'
                this.html2Pdf.skuFontSize = isLabel ? '30pt' : '50pt'
                this.html2Pdf.previewModal = previewModal
                this.html2Pdf.enableDownload = enableDownload

                this.row.preparedItems = []
                let x = 1;

                var looper = new Promise((resolve, reject) => {
                    this.row.items.forEach((val, idx, arr) => {
                        if (val.sku) {
                            var index
                            var qty = val.qty ? val.qty : 1
                            for (index = 0; index < qty; ++index) {
                                this.row.preparedItems.push({
                                    printPhoto: val.printPhoto,
                                    notes: val.notes,
                                    sku: val.sku,
                                    title: val.title,
                                    urlMed: val.urlMed,
                                    bin: val['bin' + this.row.wh],
                                    qty: qty
                                })
                                x++
                            }
                        }

                        if (idx === arr.length -1) {
                            resolve()
                        }
                    })
                })

                looper.then(() => {
                    this.$nextTick(() => {
                        this.$refs.html2Pdf.generatePdf()
                        this.html2Pdf.previewModal = false
                        this.html2Pdf.enableDownload = false
                    })
                })
            },

            onProgress(e) {

            },

            addTenRows() {
                for (var index = 0; index <= 10; index++) {
                    this.row.items.push({notes: '', printPhoto: 0, sku: '', qty: '', title: '', url: '', urlMed: '', binA: '', binB: '', suggestions: []})
                }
            },

            getValidationState({ dirty, validated, valid = null }) {
                return dirty || validated ? valid : null;
            },

            submit() {
                let row = this.row
                let url = 'api/warehousing/stocktransfer/submit'
                axios.post(url, {
                    row
                })
                .then((res) => {
                    this.showAlertBox('success', 'Stock Transfer', 'Stock transfer(s) submitted successfully!')
                    this.resetView()
                }, () => {
                    this.has_error = true
                })
            },

            fetchResults() {
                const query = this.row.items[this.currentIndex].sku;

                clearTimeout(this.autosuggest.timeout);
                this.autosuggest.timeout = setTimeout(() => {
                    const productsPromise = axios.get('api/inventory/labelgenerator/getproductsfilter/' + query);

                    Promise.all([productsPromise]).then(values => {
                        this.row.items[this.currentIndex].suggestions = []

                        // const products = this.filterResults(values[0].data, query, 'name')
                        const products = values[0].data.items

                        products.length &&
                        this.row.items[this.currentIndex].suggestions.push({ name: "products", data: products })
                    })
                }, this.autosuggest.debounceMilliseconds)
            },

            filterResults(data, text, field) {
                return data.items
                    .filter(item => {
                        if (item[field].toLowerCase().indexOf(text.toLowerCase()) > -1) {
                            return item[field]
                        }
                    })
                    .sort()
            },

            clickHandler(item) {
                let query = this.row.items[this.currentIndex].sku;
                if (!query) {
                    this.row.items[this.currentIndex].suggestions = []
                    this.row.items[this.currentIndex].title = ''
                    this.row.items[this.currentIndex].url = ''
                    this.row.items[this.currentIndex].urlMed = ''
                    this.row.items[this.currentIndex].binA = ''
                    this.row.items[this.currentIndex].binB = ''
                    this.row.items[this.currentIndex].suggestions = []
                }
            },

            onSelected(idx, sku, description, rate, url, qoh, cost, binA, binB, urlMed) {
                this.row.items[idx].sku = sku
                this.row.items[idx].title = description
                this.row.items[idx].url = url
                this.row.items[idx].urlMed = urlMed
                this.row.items[idx].binA = binA
                this.row.items[idx].binB = binB
                this.row.items[idx].suggestions = []
            },

            onInputChange(text) {
                // console.log(text)
              // event fired when the input changes
              // console.log(text)
            },

            onItemChanged(text) {
                // this.row.items[this.currentIndex].sku = text.item.name
            },

            getSuggestionValue(suggestion) {
                return suggestion.item.name
            },

            focusMe(index) {
                this.currentIndex = index

                if (this.row.items.length == index + 1) {
                    this.row.items.push({sku: '', title: '', qty: '', url: '', urlMed: '', binA: '', binB: '', suggestions: []})

                    this.scrollToElement({behavior: 'smooth'}, index + 1)
                }
            },

            onKeyTab(evt) {
                // evt.preventDefault()
                let query = this.row.items[this.currentIndex].sku.toUpperCase()

                setTimeout(() => {
                    if (this.row.items[this.currentIndex].suggestions.length) {
                        let results = this.row.items[this.currentIndex].suggestions[0].data

                        let resultName = results[0].name

                        if (resultName == query) {
                            this.row.items[this.currentIndex].sku = results[0].name
                            this.row.items[this.currentIndex].title = results[0].title
                            this.row.items[this.currentIndex].url = results[0].url
                            this.row.items[this.currentIndex].urlMed = results[0].urlMed
                            this.row.items[this.currentIndex].binA = results[0].binA
                            this.row.items[this.currentIndex].binB = results[0].binB
                            this.row.items[this.currentIndex].suggestions = []
                        } else {
                            this.row.items[this.currentIndex].suggestions = []
                        }
                    }
                }, 1500)
            },

            suggestFirst(idx, sku, description, rate, url, qoh, cost, binA, binB, urlMed) {
                this.row.items[idx].sku = sku
                this.row.items[idx].title = description
                this.row.items[idx].url = url
                this.row.items[idx].urlMed = urlMed
                this.row.items[idx].binA = binA
                this.row.items[idx].binB = binB
                this.row.items[idx].suggestions = []
            },

            filteredOptions(index) {
                return [
                    {
                        data: this.products[0].data.filter(option => {
                            return option.name.toLowerCase().indexOf(this.row.items[index].sku.toLowerCase()) > -1
                        })
                    }
                ]
            },

            // forceFileDownload(response){
            //     const url = window.URL.createObjectURL(new Blob([response.data]))
            //     const link = document.createElement('a')
            //     link.href = url
            //     link.setAttribute('download', 'Label_Generator_' + +new Date() + '.pdf') //or any other extension
            //     document.body.appendChild(link)
            //     link.click()

            //     this.showAlertBox('success', 'Label File Generated', 'Label file generated successfully!')
            // },

            // exportPDF() {
            //     let url = 'api/warehousing/labelgenerator/exportpdf'
            //     axios.post(url, {
            //         rows: this.row.items,
            //         wh: this.row.wh,
            //     },
            //     {
            //         responseType: 'blob'
            //     })
            //     .then((res) => {
            //         this.forceFileDownload(res)
            //     }, () => {
            //         this.has_error = true
            //     })
            // },

            resetView(amount) {
                this.row.items = []

                for (var index = 0; index <= amount; index++) {
                    this.row.items.push({notes: '', printPhoto: 0, sku: '', qty: '', title: '', url: '', urlMed: '', binA: '', binB: '', suggestions: []})
                }

                this.currentIndex = ''
            }
		},

        computed: {
            checkAll: {
                set(selected) {
                    this.row.items.forEach(row => {
                        row.printPhoto = selected
                    })
                },

                get() {

                }
            }
        },

        mounted() {
            this.resetView(25)

            this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
                switch (modalId) {
                    case 'modal-warehousing-labelgenerator-excel-paste':
                        this.modals[modalId].active = 0

                        break
                }
            })
        }
	}
</script>

<style lang="scss">
    #label-generator {
        .button-row {
            margin-bottom: 5px;

            .fa-file-pdf {
                color: red;
            }
        }

        table {
            td {
                vertical-align: middle;
            }

            input {
                width: 100%;
            }

            .qty {
                width: 60px;
            }

            .price {
                width: 110px;
            }

            .hide-data {
                text-decoration: line-through;
            }

            .products-thumbs {
                width: 50px;
                max-height: 50px;
            }
        }

        .options-assign {
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;

            input {
                width: 100%;
                padding: 0.5rem;
                height: calc(1.5em + 0.3rem + 2px);
            }

            ul {
                width: 100%;
                color: rgba(30, 39, 46,1.0);
                list-style: none;
                margin: 0;
                padding: 0.5rem 0 .5rem 0;
            }

            li {
                margin: 0 0 0 0;
                border-radius: 5px;
                padding: 0.75rem 0 0.75rem 0.75rem;
                display: flex;
                align-items: center;
            }

            li:hover {
                cursor: pointer;
            }

            .autosuggest-container {
                display: flex;
                // justify-content: center;
                width: 100%;

                li {
                    white-space: nowrap;
                    text-align: left;
                }
            }

            #autosuggest { width: 100%; display: block; }

            .autosuggest__results {
                position: relative;
            }

            .autosuggest__results-container {
                width: 300px;
            }

            .autosuggest__results-item--highlighted {
                background-color: rgba(51, 217, 178,0.2);
            }

            #autosuggest-autosuggest__results {
                overflow-y: hidden;
                // max-height: 200px;
            }
        }

        #pdf-content {
            border: 1px solid #000;
        }
    }
</style>
